/*
* Copyright (C) Serfim TIC
* All rights reserved
 */
import { BaseController } from '../../BaseController';
import {Filter} from "../../../model/Filter";

class CloseViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, curativeActionService,categoryService, attributeService, causeService,filterService,
                waitSpinnerService, $q, $state, $stateParams, $log, notificationService,  $mdDialog, data) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.curativeActionService = curativeActionService;
        this.categoryService = categoryService;
        this.attributeService = attributeService;
        this.causeService = causeService;
        this.filterService = filterService;
        this.$mdDialog = $mdDialog;
        this.origins = data.origins;
        this.origin = {};
        this.categories = [];
        this.category= {};
        this.attributes = [];
        this.attribut= {};
        this.causes = []//data.causes;
        this.$log.debug('Controller \'CloseViewController\' loaded');
        // Angular Material does not support Angular $onInit hook for controllers yet
        // (see https://github.com/angular/material/issues/9259)
        // That's why it is simulated hereafter. This code shall be removed if the issue above is fixed (expected in
        // Angular Material 1.2.0)
        this.initialized = false;
        this.$onInit();
    }

    $onInit() {
        if (this.initialized) {
            this.$log.warn('CloseViewController.$onInit called twice: issue 9259 may have been fixed');
        } else {
            super.$onInit();
            this.initialized = true;
        }
    }

    save() {
        this.$mdDialog.hide(this.model);
    }

    cancel() {
        this.$mdDialog.hide();
    }

    initCategories(selectedOrigin) {
        this.category={};
        this.handleRestServiceCall(
            this.categoryService.findEntities({
                params: this.filterService.buildSortingParam({sort: 'code'}),
                data: this.filterService.buildFilters([
                    Filter.equalFilter('origin.id', selectedOrigin, 'model.domain.domain')
                ])
            }), categories => {
            this.categories= categories;
        });
    }

    initAttributes(selectedCategory) {
        this.attribut={};
        this.handleRestServiceCall(
            this.attributeService.findEntities({
                params: this.filterService.buildSortingParam({sort: 'code'}),
                data: this.filterService.buildFilters([
                    Filter.equalFilter('category.id', selectedCategory, 'model.domain.domain')
                ])
            }), attributes => {
            this.attributes= attributes;
        });
    }

    initCauses(selectedAttribute) {
        this.model={};
        this.handleRestServiceCall(
            this.causeService.findEntities({
                params: this.filterService.buildSortingParam({sort: 'value'}),
                data: this.filterService.buildFilters([
                    Filter.equalFilter('attribute.id', selectedAttribute, 'model.domain.domain')
                ])
            }), causes => {
                this.causes = causes;
            });
    }


}

export { CloseViewController };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/component/CloseView.js